import { Box } from '@mui/material';

import AddApp from '@/assets/icons/AddApp';
import Typography from '@/components/Typography';

type AddAppButtonProps = {
  onClick: () => void;
};
export const AddAppButton = ({ onClick }: AddAppButtonProps) => {
  return (
    <Box
      component='button'
      sx={{
        minHeight: '40vh',
        p: 0,
        backgroundColor: 'background.paper',
        display: 'flex',
        flexDirection: 'column',
        cursor: 'pointer',
        gap: 1,
        border: 'none',
        color: 'text.primary',
        fontFamily: theme => theme.typography.fontFamily,
        transition:
          'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        '&:hover': {
          backgroundColor: 'secondary.dark'
        }
      }}
      onClick={onClick}
    >
      <Box
        sx={{
          width: 112,
          height: 48,
          borderBottomColor: 'primary.main',
          borderBottomWidth: 2,
          borderBottomStyle: 'solid',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'gx.tileLight',
          color: 'gx.textDisabled'
        }}
      >
        Tab
      </Box>
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'center',
          flex: 1,
          flexDirection: 'column',
          gap: 2
        }}
      >
        <Box
          sx={{
            width: '64px',
            height: '64px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'gx.tileLight'
          }}
        >
          <AddApp
            fill='#6C737A'
            sx={{
              width: '24px',
              height: '24px'
            }}
          />
        </Box>
        <Typography
          size={14}
          sx={{ color: 'gx.textDisabled' }}
        >
          Your app will appear here
        </Typography>
      </Box>
    </Box>
  );
};
